const module = { name: 'news/overview/wall', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

const { context: { req: { params: { hub } } } } = Fandango_context;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { fd_url_manager as links } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';



const Selectors = {
    CONTAINER: '.content-item-list.wall',
    ITEM_SELECTOR: '.content-item-container',
    MORE_BTN: '#more-button'
}


const Styles = {
    HIDE: 'hide-item',
}


let $container
function onImagesLoaded() {
    $container.isotope({
        itemSelector: Selectors.ITEM_SELECTOR
    });
    $(window).on('resize', $.debounce(250, () => $container.isotope()));
}
function onDone(data) {
    const $moreBtn = $(Selectors.MORE_BTN);
    if (data.done) {
        return $moreBtn.hide();
    }
    const $items = $(Selectors.ITEM_SELECTOR, data.markup);
    $items
        .addClass(Styles.HIDE)
        .appendTo($container)
        .imagesLoaded(() => {
        $container.isotope('appended', $items);
        $items.removeClass(Styles.HIDE);
        $moreBtn
            .text($moreBtn.data('text-state-default')).removeAttr('disabled')
            .data('next-page', data.nextPage);
    });
}
function onFail() {
    const $moreBtn = $(Selectors.MORE_BTN);
    $moreBtn.hide();
}
function onBtnClick() {
    const $moreBtn = $(this);
    $moreBtn.text($moreBtn.data('text-state-loading')).attr('disabled', 'disabled');
    xhr.ajax({
        method: 'GET',
        url: links.napiHubOverviewPager({
            page: $moreBtn.data('next-page'),
            hub
        }),
    })
        .done(onDone)
        .fail(onFail);
}
function init() {
    $container = $(Selectors.CONTAINER);
    $container.imagesLoaded(onImagesLoaded);
    $(Selectors.MORE_BTN).on('click', onBtnClick);
}
module.exports = {
    init,
};
export default module.exports;